import React from 'react';
import _noop from 'lodash/noop';
import { useStyletron } from 'baseui';

import { EMPTY_OBJECT, FormBuilder } from 'commons-ui';

import { IContentProps } from '../types';
import {
	FORM_FIELD_CONFIG,
	FORM_LAYOUT_CONFIG_UPDATE_USER_FRAUD_STATUS,
	validationSchemaUpdateUserFraudStatus
} from '../utils/formConfig';
import useContent from '../utils/useContent';

const Content = (props: IContentProps) => {
	const { handleForceUpdate = _noop, adminActionType } = props;
	const [css] = useStyletron();

	const { showLoader, setShowLoader, handleUpdateUserFraudStatusFormCancel, handleUpdateUserFraudStatusFormSubmit } = useContent({
		handleForceUpdate,
		adminActionType
	});

	return (
		<div className={css({ width: '50vw' })}>
			<FormBuilder
				data={EMPTY_OBJECT}
				mode='create'
				showLoader={showLoader}
				handleFormSubmit={handleUpdateUserFraudStatusFormSubmit}
				handleFormCancel={handleUpdateUserFraudStatusFormCancel}
				setShowLoader={setShowLoader}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG_UPDATE_USER_FRAUD_STATUS}
				validationSchema={validationSchemaUpdateUserFraudStatus}
				hidePopUp
			/>
		</div>
	);
};

export default Content;
